import type { PropsWithChildren } from 'react';
import React from 'react';
import styled, { css } from 'styled-components';
import { Text } from '../atoms';
const ErrorContainer = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.main};
    background-color: ${theme.colors.main.error};
  `
);

const Error = ({ children }: PropsWithChildren) => {
  return (
    <ErrorContainer>
      <Text>{children}</Text>
    </ErrorContainer>
  );
};

export { Error };
